import { useNavigate } from "react-router-dom"
import { Address } from "../../../../../features/address"
import { Emitter, Event } from "../../../../../features/event-emitter"
import { RoutePath, useRoutesHooks } from "../../../../../features/routes"
import { TableName } from "../../../../../tables"
import { DeliveryData } from "../../../../deliveries"
import { Item } from "../../../../operations"
import { useCustomerService } from "../../../services/customerService"
import { PendingFinancialDelivery, useHoardService } from "../../../services/hoardService"
import { Customer } from "../../../state/types"

export const useActions = () => {
    const { getRoutePath } = useRoutesHooks()
    const navigate = useNavigate()

    const { emitFinancialDeliveryOrder } = useHoardService()
    const { updateCustomerProps } = useCustomerService()

    const submitCustomerDeliveryAddress = (
        customer: Customer,
        address: Address
    ) => {
        const deliveryAddresses = customer.deliveryAddresses.concat(address)
        return updateCustomerProps(customer.id, { deliveryAddresses })
    }

    const buildDeliveryOrderData = (
        table: TableName,
        hoardId: string,
        deliveryData: Partial<DeliveryData>
    ) => ({
        table,
        operationId: hoardId,
        method: deliveryData.method,
        deliveryDate: deliveryData.deliveryDate,
        addressId: deliveryData.addressId
    })

    const emitDelivery = async (
        table: TableName,
        hoardId: string,
        deliveryData: Partial<DeliveryData>,
        itemsData: Partial<Item>[]
    ) => {
        Emitter.emit(Event.DB_SUBMIT)

        await emitFinancialDeliveryOrder(hoardId, buildDeliveryOrderData(table, hoardId, deliveryData), itemsData)

        Emitter.emit(
            Event.DB_SUBMIT_DONE,
            true,
            false,
            getRoutePath(RoutePath.HOARDS, hoardId)
        )
    }

    // El excedente sobre el crédito del acopio se cobra en el momento: la entrega (y la ampliación) se guardan
    // recién al confirmar el cobro, igual que una ampliación manual
    const collectAndEmitDelivery = (
        table: TableName,
        hoardId: string,
        deliveryData: Partial<DeliveryData>,
        itemsData: Partial<Item>[],
        increaseAmount: number
    ) => {
        const pendingDelivery: PendingFinancialDelivery = {
            deliveryOrderData: buildDeliveryOrderData(table, hoardId, deliveryData),
            itemsData
        }
        navigate(`${getRoutePath(RoutePath.HOARDS, hoardId)}/${RoutePath.CONFIRM_PAYMENT}`, { state: { increaseAmount, pendingDelivery } })
    }

    return {
        submitCustomerDeliveryAddress,
        emitDelivery,
        collectAndEmitDelivery
    }
}
